import { gql } from '@apollo/client';
import { NEW_CAMPAIGN } from '../fragments/campaign';

export const GET_CAMPAIGN_BY_ID = gql`
  query GetCampaignById($id: ID!) {
    campaign(id: $id) { ...NewCampaign }
  }
  ${NEW_CAMPAIGN}
`;

const CAMPAIGN_LIST_FIELDS = gql`
  fragment CampaignListFields on CampaignList {
    campaigns { ...NewCampaign }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
  ${NEW_CAMPAIGN}
`;

export const GET_CAMPAIGNS = gql`
  query GetCampaigns($input: FilterCampaignList!) {
    campaigns(input: $input) {
      ...CampaignListFields
    }
  }
  ${CAMPAIGN_LIST_FIELDS}
`;

export const GET_CAMPAIGNS_MODAL = gql`
  query GetCampaignsModal($input: FilterCampaignList!) {
    campaigns(input: $input) @connection(key: "modal") {
      ...CampaignListFields
    }
  }
  ${CAMPAIGN_LIST_FIELDS}
`;
